import { Box, Button } from "@chakra-ui/react";
import ErrorDetails from "components/ErrorDetails";
import useTranslate from "hooks/useTranslate";
import { Link } from "react-router-dom";

const NotFoundMessage = () => {
  const translate = useTranslate();

  return (
    <Box bg="dark.900" py="12" px="12" maxW="xs">
      <ErrorDetails
        title={translate("error:notFound:title")}
        description={translate("error:notFound:description")}
      >
        <Link
          to="/"
          style={{
            display: "block",
            width: "100%",
          }}
        >
          <Button as="span" colorScheme="secondary" w="full">
            {translate("error:notFound:backToHome")}
          </Button>
        </Link>
      </ErrorDetails>
    </Box>
  );
};

export default NotFoundMessage;
